import paths from "paths";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import type { NavigateFunction } from "react-router-dom";

enum MenuAction {
  Logout,
  Navigate,
}

const MenuItems = [
  {
    title: "Your account",
    route: `/${paths.authenticated.ACCOUNT}`,
    danger: false,
    action: MenuAction.Navigate,
  },
  {
    title: "Log out",
    icon: FaArrowRightFromBracket,
    danger: true,
    action: MenuAction.Logout,
  },
];

const AdminMenuItems = [
  {
    title: "Manage users",
    route: `/${paths.admin.MANAGE_USERS}`,
    danger: false,
    action: MenuAction.Navigate,
  },
];

type MenuItem = {
  title: string;
  onClick: () => void;
  icon?: any;
  danger: boolean;
};

type ElementType<T> = T extends (infer U)[] ? U : never;

const intoMenuItem = (
  menuItem: ElementType<typeof MenuItems>,
  onClick: () => void,
): MenuItem => {
  return {
    title: menuItem.title,
    onClick: onClick,
    icon: menuItem.icon,
    danger: menuItem.danger,
  };
};

const createMenuItems = (
  menuItems: typeof MenuItems,
  navigationFn: NavigateFunction,
  logout: () => void,
): MenuItem[] => {
  return menuItems
    .map((value) => {
      switch (value.action) {
        case MenuAction.Navigate:
          return intoMenuItem(value, () => navigationFn(value.route!));
        case MenuAction.Logout:
          return intoMenuItem(value, logout);
        default:
          return undefined;
      }
    })
    .filter((value) => value !== undefined) as MenuItem[];
};

export { createMenuItems, intoMenuItem, MenuItems, AdminMenuItems };

export type { MenuItem };
